import { BagsService } from '@/modules/bags/services/bags.service';
import { indicateWheatType } from '@/modules/common/helpers/wheat-type.helper';
import { DiContainer } from '@/modules/di/di-container';
import { Modal, notification } from 'antd';
import { IWheatData } from '../ts/index.types';

const bagsService = DiContainer.get(BagsService);

export const setWheatClassFormOrigin = async (
  currentId: number,
  searchState: IWheatData,
  setSearchState: (val: IWheatData) => void,
) => {
  if (!searchState.type || !searchState.sort)
    return notification.warning({ message: 'Необходимо указать сорт и тип пшеницы' });
  const res: any = await bagsService.getClassParams(
    currentId,
    Number(indicateWheatType(searchState.sort, searchState.type)),
  );
  if (!res)
    return notification.error({
      message: 'Ошибка загрузки параметров зерна. Попробуйте, пожалуйста, позже',
    });
  return Modal.confirm({
    title: 'Подтвердите действие',
    content:
      'Данное действие переустановит параметры зерна, на соответсвующие для выбранного класа, Вы уверены что хотите продолжить?',
    okText: 'да',
    cancelText: 'нет',
    onOk: () => {
      const parameters: any = {
        gluten: res?.gluten || 0,
        idk: res?.idk || 0,
        clop: res?.clop || 0,
        protein: res?.protein || 0,
        cp: res?.hfn || 0,
        nature: res?.density || 0,
        humidity: res?.moisture || 0,
      };
      setSearchState({ ...searchState, class: currentId, params: parameters });
      //   setInputs({ ...inputs, parameters });
      //   setIndicatedClass(currentId);
    },
  });
};
